import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CountOtorPenggunaModel, PenggunaChangePasswordModel, PenggunaChangePasswordUserModel, PenggunaDataModel, PenggunaDatatablesReqModel, PenggunaDatatablesResModel, PenggunaIdModel, PenggunaSetAktifModel, PenggunaSetLockModel } from '../../../_model/user-management/pengguna.model';
import { DatatablesModelResponse } from '../../../_model/utils/datatables.model';

@Injectable({
  providedIn: 'root'
})
export class UmPenggunaService {

  constructor(
    private _http: HttpClient
  ) { }

  public save(value: PenggunaDataModel) {
    return this._http.post(`${environment.uriAuth}/api/um/pengguna/save`, value, {observe: 'response'});
  }

  public changePassword(value: PenggunaChangePasswordModel) {
    return this._http.put(`${environment.uriAuth}/api/um/pengguna/change-password`, value, {observe: 'response'});
  }

  public changePasswordLama(value: PenggunaChangePasswordUserModel) {
    return this._http.put(`${environment.uriAuth}/api/um/pengguna/change-password-lama`, value, {observe: 'response'});
  }

  public setLock(value: PenggunaSetLockModel) {
    return this._http.put(`${environment.uriAuth}/api/um/pengguna/set-lock`, value, {observe: 'response'});
  }

  public setAktif(value: PenggunaSetAktifModel) {
    return this._http.put(`${environment.uriAuth}/api/um/pengguna/set-aktif`, value, {observe: 'response'});
  }

  public findById(id: number) {
    return this._http.get<PenggunaDataModel>(`${environment.uriAuth}/api/um/pengguna/find-by-id/${id}`, {observe: 'response'});
  }

  public getIdByNrk(nrk: string) {
    return this._http.get<PenggunaIdModel>(`${environment.uriAuth}/api/um/pengguna/get-id-by-nrk/${nrk}`, {observe: 'response'});
  }

  public datatables(parameters: any, value: PenggunaDatatablesReqModel) {
    let params = new HttpParams();
    params = params.append('start', parameters.start);
    params = params.append('length', parameters.length);
    params = params.append('draw', parameters.draw);
    params = params.append('order[0][column]', parameters.order[0]['column']);
    params = params.append('order[0][dir]', parameters.order[0]['dir']);
    return this._http.post<DatatablesModelResponse>(`${environment.uriAuth}/api/um/pengguna/datatables`, value, {params: params});
  }

  public deleteById(id: number) {
    return this._http.delete(`${environment.uriAuth}/api/um/pengguna/delete-by-id/${id}`, {observe: 'response'});
  }

  public deleteByList(value: Array<PenggunaDatatablesResModel>) {
    return this._http.post(`${environment.uriAuth}/api/um/pengguna/delete-by-list`, value, {observe: 'response'});
  }

  public countOtorOfPengguna(id: number) {
    return this._http.get<CountOtorPenggunaModel>(`${environment.uriAuth}/api/um/pengguna/count-otor-pengguna/${id}`, {observe: 'response'});
  }

  public findPenggunaMoreThanOneOtor(id: number) {
    return this._http.get<PenggunaDataModel>(`${environment.uriAuth}/api/um/pengguna/find-pengguna-more-one-otor/${id}`, {observe: 'response'});
  }

}
